// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuButton-9P-py__wrapper","menu-icon":"MenuButton-7YNlM__menu-icon","title":"MenuButton-FAsnT__title"};